import { useRouter } from 'next/router'
import React from 'react'
import { ArrowUpRight, Lock } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'

interface AppStorePromoCardProps {
  heading: string
  subheading: string
  appId?: string
  appDetailPath?: string
}

export const AppStorePromoCard = ({ heading, subheading, appId, appDetailPath }: AppStorePromoCardProps) => {
  const { t } = useLocale()
  const router = useRouter()

  return (
    <div className='flex p-2 justify-between items-center border border-gray-light rounded-lg'>
      <div className='flex flex-row space-x-2 items-center justify-start'>
        <div className='flex items-center justify-center bg-[#EFD0801A] rounded-lg p-2'>
          <Lock size={16} className='text-[#A7893B]' strokeWidth={2.5} />
        </div>
        <div className='flex flex-col space-y-1'>
          <p className='text-sm text-coal-dark font-medium'>{heading}</p>
          <span className='text-xs text-coal-light font-normal'>{subheading}</span>
        </div>
      </div>
      <button
        className='flex items-center justify-center bg-white rounded-lg py-2 px-3 border border-gray-light text-sm text-coal-dark font-medium'
        onClick={() => {
          if (appDetailPath) {
            router.push(appDetailPath)
          } else if (appId) {
            router.push(`/apps-integrations/detail?id=${appId}`)
          } else {
            router.push('/apps-integrations')
          }
        }}
      >
        <span>{t('enable')}</span>
        <ArrowUpRight size={16} className='text-coal-dark' strokeWidth={2.5} />
      </button>
    </div>
  )
}
